export const siteVisitReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_SITE_VISIT_LIST_REQUEST":
      return {
        ...state,
        loading: true,
      };

    case "GET_SITE_VISIT_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        siteVisitList: action.payload,
      };

    case "GET_SITE_VISIT_LIST_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "GET_SITE_VISIT_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_SITE_VISIT_SUCCESS":
      return {
        ...state,
        loading: false,
        siteVisit: action.payload,
      };
    case "GET_SITE_VISIT_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "RESET_SITE_VISIT":
      return {
        ...state,
        siteVisit: null,
        error: null,
      };
    default:
      return state;
  }
};
